// extracted by mini-css-extract-plugin
export default {"revealedToken":"styles-module__p81yJ"};